export const seasonalAllergy = {
  title: {
    anyOfTheseSymptoms: 'Do you have any of these symptoms?',
    anyOfTheseApply: 'Do any of these apply to you?',
    whichSymptoms: 'Which symptoms do you have?',
    howLong: 'How long have you had these symptoms?',
    pregnantChance: 'Is there a chance you might be pregnant?',
    wereExposed: 'Were you exposed to the flu?',
    covidTest: 'Did you have positive home COVID test',
  },
  subtitle: {
    wantMakeSure: 'We want to make sure you don’t have something serious.',
  },
  options: {
    swelling: 'Lip or tongue swelling',
    difficultyBreathing: 'Difficulty breathing, speaking, or swallowing',
    spreadingRash: 'Spreading rash',
    sneezing: 'Sneezing',
    itchy: 'Itchy, watery eyes',
    scratchyThroat: 'Scratchy throat',
    chanceToBePregnant: 'There is a chance I can be pregnant',
    historyOf: 'History of unsuccessfully treated allergies',
    medicalCondition: 'Medical condition that puts me at higher risk of infection',
    fever: 'Fever or chills',
    muscleAches: 'Muscle aches',
    diarrhea: 'Diarrhea',
    soreThroat: 'Sore throat',
    headache: 'Headache',
    cough: 'Cough',
    runnyNose: 'Runny nose',
    congestion: 'Congestion',
    diabetes: 'Diabetes',
    lungDisease: 'Lung disease',
    tobacco: 'Tobacco use',
    hospitalization: 'Hospitalization for lung infection',
    over65: 'Over 65 years old',
    yes: 'Yes',
    no: 'No',
  },
};
